module.exports = __webpack_public_path__ + "static/img/preview-2.131c40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-2.png
// module id = 3yAL
// module chunks = 35